import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["total", "factor"]
  
  update(){
    
      let total = 1.0
      this.factorTargets.forEach( item => {
        total *= parseFloat(item.value)
      })
      this.totalTarget.value = total;
  }
}
